<div
  class="fixed inset-x-0 top-0 z-30 flex items-center gap-2 bg-surface px-4 py-2 shadow mdx:hidden"
>
  <img
    src="assets/img/portal/nuevo-Rayo-logo-columna-izq.webp"
    alt="Rayo"
    class="w-28 cursor-pointer"
    (click)="onClickGoToMainPage()"
  />
  <span class="flex-auto"></span>
  <button
    type="button"
    (click)="menu.emit()"
    aria-label="Abrir menú"
    class="grid h-10 w-10 place-items-center rounded-md text-primary transition-colors hover:bg-ink/5 cursor-pointer"
  >
    <i class="pi pi-bars text-xl"></i>
  </button>
</div>
